import React from 'react';
import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { useSearchActionResolver, useSuggestionActionResolver, useRunDomainAction, useDomainActionStatus } from './hooks';
import { ActionsContext } from './context';
export const ActionsExtension = createModuleExtension({
  extensionName: 'actions',
  SDK: {
    useSearchActionResolver,
    useSuggestionActionResolver,
    useRunDomainAction,
    useDomainActionStatus
  },
  Provider: _ref => {
    let _ref$siteInfo = _ref.siteInfo,
      siteInfo = _ref$siteInfo === void 0 ? {
        externalViewer: false
      } : _ref$siteInfo,
      _ref$statusesOverride = _ref.statusesOverrides,
      statusesOverrides = _ref$statusesOverride === void 0 ? {} : _ref$statusesOverride,
      _ref$handlers = _ref.handlers,
      handlers = _ref$handlers === void 0 ? {} : _ref$handlers,
      _ref$enabledActions = _ref.enabledActions,
      enabledActions = _ref$enabledActions === void 0 ? [] : _ref$enabledActions,
      _ref$uiConfig = _ref.uiConfig,
      uiConfig = _ref$uiConfig === void 0 ? {} : _ref$uiConfig,
      autoInvokeOverride = _ref.autoInvokeOverride,
      resolveCorrectedDomains = _ref.resolveCorrectedDomains,
      children = _ref.children;
    return /*#__PURE__*/React.createElement(ActionsContext.Provider, {
      value: {
        statuses: statusesOverrides,
        siteInfo,
        handlers,
        enabledActions,
        uiConfig,
        autoInvokeOverride,
        resolveCorrectedDomains
      }
    }, children);
  }
});
//# sourceMappingURL=actions.extension.js.map